import { unwrapResult } from "@reduxjs/toolkit"
import { Button, Checkbox, Col, Form, Radio, Row, Space, Table, notification } from "antd"
import React, {
  ReactElement,
  useContext,
  useEffect,
  useState,
  useRef,
  useMemo,
} from "react"
import { useDispatch, useSelector } from "react-redux"
import { selectTenantName } from "../../../app/applicationSlice"
import { RootDispatch } from "../../../app/store"
import { PrintFrame, PrintFrameRef } from "../../print/PrintFrame"
import { DoctorSaleEntry, DoctorSalesResult } from "../../../models/doctorSales"
import {
  DateRangeFieldName,
  DateRangeNoYearTypes,
  DateRangeType,
  DateSelect,
  getDateRange,
  TJFXTime,
} from "../../../compnents/form/DateSelect"
import { DrugCostEntry } from "../../../models/drugCost"
import { ThemeContext } from "../../../theme/ThemeContext"
import styles from "./doctoAchievement.module.css"
import { getDoctorAchievementAsync, getDoctorAchievementExportAsync } from "./achievement"
import moment from "moment"
import { DoctorAchievementColumns } from "./column"
import { getCheckPermissionAsync } from "../../FunctionSetting/dataPermission/dataPermissionSlice"
import { SJQXChecks } from "../../../models/dataPersion"

export const DoctorAchievement = (): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const [form] = Form.useForm()

  const [timeHead, timeTail] = getDateRange(DateRangeType.Today)

  const [params, setParams] = useState({
    timeHead,
    timeTail,
    [DateRangeFieldName]: DateRangeType.Today,
  })

  const name = useSelector(selectTenantName)

  const [data, setData] = useState<any[]>([])

  const printRef = useRef<PrintFrameRef>(null)

  const [CKLRSJData, setCKLRSJData] = useState<any>(true)

  const [categoryValue, setCategoryValue] = useState(false) //按处方分类

  const [pageLoading, setPageLoading] = useState(false) //表格 loading

  const [exportLoading, setExportLoading] = useState(false) //导出 loading

  const getData = () => {
    try {
        setPageLoading(true)
        dispatch(getDoctorAchievementAsync(params))
          .then(unwrapResult)
          .then((data: any) => {
            setData(data)
          })
          .finally(() => setPageLoading(false))
      } catch {
        // do nothing.
      }
  }

  useEffect(() => {
    getCheckPermissionFn()
  }, [])

  // 获取查看利润数据权限
  const getCheckPermissionFn = () => {
    dispatch(getCheckPermissionAsync({ itemCode: SJQXChecks.CKLRSJ }))
      .then(unwrapResult)
      .then((res: any) => {
        setCKLRSJData(res)
      })
  }

  useEffect(() => {
    getData()
  }, [params])

  useEffect(() => {
    form.setFieldsValue(params)
  }, [])

  const table = (type = false) => (
    <>
      <Table
        className={type ? styles.tables : styles.table}
        pagination={false}
        rowClassName={(e) =>
          e.treatmentDoctorName === '合计' ? styles.total : e.categoryName === '分类合计'
            ? styles.highlight
            : ''
        }
        loading={pageLoading}
        dataSource={data}
        bordered
        rowKey={(_, i) => `${i}}`}
        style={{ flex: 1, overflow: "auto" }}
        columns={DoctorAchievementColumns(categoryValue ? 1 : 0,data,CKLRSJData)}
      />
    </>
  )

  const tablePrint = (type = false) => (
    <>
      <Table
        className={type ? styles.tables : styles.table}
        pagination={false}
        rowClassName={(e) =>
          e.treatmentDoctorName === '合计' ? styles.total : e.categoryName === '分类合计'
            ? styles.highlightPrint
            : ''
        }
        loading={pageLoading}
        dataSource={data}
        bordered
        rowKey={(_, i) => `${i}}`}
        style={{ flex: 1, overflow: "auto" }}
        columns={DoctorAchievementColumns(categoryValue ? 1 : 0,data,CKLRSJData)}
      />
    </>
  )

  const outClued = () => {
    setExportLoading(true)
    dispatch(getDoctorAchievementExportAsync(params))
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = '医生业绩统计.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
          duration: 3,
        })
      })
      .catch((res: any) => {
        return
      })
      .finally(() => setExportLoading(false))
  }
  return (
    <Col
      style={{
        height: "calc(100% - 30px)",
        padding: "20px 15px",
        borderRadius: theme.br,
        backgroundColor: theme.pn,
        marginTop: 10,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <Form
        form={form}
        onFinish={(values) => {
          const monthDiff = moment(values?.timeTail).diff(moment(values?.timeHead), 'months', true)
          if (monthDiff > 1) {
            notification.error({
              message: '时间间隔不能超过1个月',
              duration: 3,
            })
            return
          }
          if (!values?.timeHead && values?._dateRange == 6) {
            return
          }
          setParams({ ...params, ...values, category: categoryValue ? 1 : undefined })
        }

        }
      >
        <Row
          style={{ marginBottom: 10 }}
          align="middle"
          justify="space-between"
        >
          <Space>
            <DateSelect
              style={{ width: "8.5rem" }}
              labelPrefix=""
              allowClear={false}
              options={DateRangeNoYearTypes}
              namePrefix="time"
              placeholder="业绩统计-时间"
              initialValue={DateRangeType.Today}
              onChange={form.submit}
            />
            <Checkbox
              disabled={pageLoading}
              checked={categoryValue}
              onChange={(e) => {
                setCategoryValue(e.target.checked)
                form.submit()
              }}
            >
              按处方分类
            </Checkbox>
            <Button type="primary" onClick={form.submit} loading={pageLoading}>
              查询
            </Button>
          </Space>
          <Space>
            <Button type="primary" onClick={(()=>{
              dispatch(getCheckPermissionAsync({ itemCode: SJQXChecks.DCDYQX }))
                .then(unwrapResult)
                .then((res: any) => {
                  outClued()
                })
            })} loading={exportLoading}>
              导出
            </Button>
            <Button type="primary"
              onClick={() => {
                dispatch(getCheckPermissionAsync({ itemCode: SJQXChecks.DCDYQX }))
                  .then(unwrapResult)
                  .then((res: any) => {
                    printRef.current?.print()
                  })
              }}>
              打印
            </Button>
          </Space>
        </Row>
        {/* <div
          style={{
            position: "relative",
            textAlign: "center",
            color: theme.tc1,
            fontWeight: "bold",
            fontSize: "1.5rem",
            marginBottom: 10,
          }}
        > */}
          {/* {name}-业绩统计 */}
          {/* <div className={styles.medicalType}>
            <Form.Item name="type">
                <Radio.Group
                    onChange={() => form.submit()}
                >
                    <Radio value={0}>全部</Radio>
                    <Radio value={1}>药品</Radio>
                    <Radio value={2}>诊疗</Radio>
                </Radio.Group>
            </Form.Item>
          </div> */}
        {/* </div> */}
      </Form>
      {table()}
      <PrintFrame
        ref={printRef}
        title={
          JSON.parse(localStorage.getItem("credentials") as string)?.tenantName
        }
      >
        <Row style={{ lineHeight: "32px", textAlign: "right" }}>
          <Col span={13}>医生业绩统计</Col>
          <Col span={11}>
            日期：{form.getFieldValue("timeHead")?.split(" ")[0]} -{" "}
            {form.getFieldValue("timeTail")?.split(" ")[0]}
          </Col>
        </Row>
        {tablePrint(true)}
      </PrintFrame>
    </Col>
  )
}
